// extracted by css-extract-rspack-plugin
export default {"cls1":"TruncateHeight-cls1_-5v","cls2":"TruncateHeight-cls2_5HM TruncateHeight-cls1_-5v"};